<template>
    <div id="edit">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-graduation-cap"></i> Schools</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">
                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="school.name" rules="required" placeholder='Name'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="url" v-model="school.url" rules="" placeholder='Url'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="logo" v-model="school.logo" rules="" placeholder='Logo'/>
                    </div>
                </div>

                <div class="column is-6" v-if="schools && schools.length > 0">
                    <div class="field">
                        <div class="select is-fullwidth">
                            <select v-model="school.school_id">
                                <option v-bind:value="school.id" v-for="school in schools">{{school.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns is-multiline"> 
                <div class="column is-2">                    
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>                    
                </div>              
                <div class="column is-2 is-offset-8 is-pulled-right">                                           
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>                   
                </div>              
            </div>                      
        </form>
    </div>  
</template>

<script>
import SchoolRepo from '../../repos/SchoolRepo'
import _ from 'lodash'

export default {
  name: 'schools-edit',
  components: {},
  data() {
        return {
            repo: new SchoolRepo(this.$auth),
            loading: false,
            schools: [],
            school: {},
        }
  },
  created(){
    this.getSchool(this.$route.params.id);
  },
  methods: {
    getSchool(id){
        this.repo.show(id).then(response => {
            this.school = response.data.data;
        });
    },
    save(){            
        this.$validator.validateAll().then((result) => {
	    if (result) {
                let self = this;
                this.loading = true;                                
                
                this.repo.update(this.school.id, this.school).then(function (response) {
                    
                    self.loading = false;
                    self.$toast.success(response.data.message);
                    self.$router.push('/dashboard/schools');
                }).catch(function(response){
                    self.loading = false;                    
                    return Promise.reject(response);
                });
            }
        });
    
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/schools/Edit.vue